import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=58d5709f&scoped=true"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5709f",
  null
  
)

export default component.exports